const password_restore = {
    title: String("Recuperació de contrasenya"),
    newPasswordAsk: String("Introduir la nova contrasenya."),
    changePasswordButton: String("Canviar la contrasenya"),
    passwordChanged: String("La contrasenya s'ha canviat correctament."),
    emailNotFound: String("El correu electrònic no existeix, introduïu un correu electrònic vàlid."),
    keyError: String("Hi ha algun problema amb l'enllaç de recuperació de contrasenya. Feu clic al botó de correu electrònic o bé torneu a omplir el formulari 'Heu oblidat la vostra contrasenya?'."),
};

export default password_restore;